import { searchEntityRecords } from "../utils/apiUtils"
import { ENTITY_NAME_PERMISSION } from "./dbConstants";


export const getAll = async() => {
  console.log("PermissionDAO.getAll - input:");
  const searchParams = {pageNumber: 1, pageSize: -1}
  searchParams.group = {
    operator: 'AND',
    criteria: [{
      fieldName: 'isBackend',
      operator: '=',
      value: 'false',
    }]
  };
  return searchEntityRecords(ENTITY_NAME_PERMISSION, searchParams);
}